import {Optional} from "../../../js/util/Optional";
import "./GameWelcomeWizard.scss";
import {
    AGE_GROUPS,
    CONNECTED_BROKERS,
    DEFAULT_SETUP_DATA,
    ONLINE_BROKERS,
    OTHER_BROKERS,
    VALUE_BROKERS
} from "./GameWelcomeWizardConstants";

export class GameWelcomeWizardController {

    static id = "gameWelcomeWizardCtl";

    legals = null;
    ageGroups = null;

    wizardState = {
        terms: false
    };

    currentStepNumber = 0;
    isBrokerListOpen = false;

    connectedBrokersSearch = "";
    valueBrokers = VALUE_BROKERS;
    connectedBrokers = CONNECTED_BROKERS;
    onlineBrokers = ONLINE_BROKERS;
    otherBrokers = OTHER_BROKERS;

    manualBroker = "";

    enteredStep = {
        personal: true,
        experience: null,
        terms: null
    };

    setupData = Object.assign({}, DEFAULT_SETUP_DATA);

    /** @ngInject */
    constructor($http, userConfig, $window, $uibModalInstance, userService) {
        this.$http = $http;
        this.userConfig = userConfig;
        this.$window = $window;
        this.$uibModalInstance = $uibModalInstance;
        this.userService = userService;
    }

    $onInit() {
        this.initLegalContent();
        this.ageGroups = AGE_GROUPS;
        this.guessFullName();
    }

    guessFullName() {
        if (this.userConfig.profile.givenName != null) {
            this.setupData.givenName = this.userConfig.profile.givenName;
            this.setupData.surname = this.userConfig.profile.surname;
        } else {
            const fullName = this.userConfig.shortName;
            const split = fullName.split(" ");
            const givenName = split[0];
            const surnameIndex = Math.max(1, split.length - 1);
            const surname = split[surnameIndex];
            this.setupData.givenName = givenName;
            this.setupData.surname = surname;
        }
        this.setupData.phone = Optional.of(this.userConfig)
                                       .map((c) => c.profile)
                                       .map((p) => p.phone)
                                       .orNull();
    }

    async initLegalContent() {
        const response = await this.$http.get("app/layout/legal/legal.json");
        const data = response.data;

        function htmlify(value) {
            const bold = /“(.*?)”/g;
            const italic = /‘(.*?)’/g;
            return value.replace(bold, "<b>“$1”</b>").replace(italic, "<i>‘$1’</i>");
        }

        this.legals = data[this.userConfig.broker] || data.TF;

        this.legals.introParagraphs = this.legals.introParagraphs.map(htmlify);
        this.legals.sections.forEach((s) => s.content = htmlify(s.content));
    }

    next() {
        this.currentStepNumber = this.currentStepNumber + 1;
    }

    back() {
        this.currentStepNumber = this.currentStepNumber - 1;
    }

    stepPersonalEntered() {
        this.enteredStep.personal = true;
    }

    stepExperienceEntered() {
        this.enteredStep.experience = true;
    }

    stepTermsEntered() {
        this.enteredStep.terms = true;
    }

    async acceptTerms() {
        this.$http.put("/tradefloor/api/user/legal/terms");
        this.complete();
    }

    async declineTerms() {
        const response = await this.$http.get("/tradefloor/api/logout");
        this.$window.location.href = response.headers("location") || "/";
    }

    onPhoneChanged(value) {
        this.setupData.phone = value;
        this.userService.updateContactNumber(this.setupData.phone);
    }

    async complete() {
        this.savePersonal();
        this.saveDemographics();
        this.completeOnboard();
        this.$uibModalInstance.close();
    }

    async savePersonal() {
        this.userService.updateFullName(this.setupData.givenName, this.setupData.surname);
    }

    async saveDemographics() {
        const demographics = this.buildDemographics();
        this.$http.post("/tradefloor/api/user/demographics", demographics);
    }

    async completeOnboard() {
        this.$http.put("/tradefloor/api/user/onboard");
    }

    buildDemographics() {
        return {
            country: this.setupData.country,
            state: this.setupData.state,
            postCode: this.setupData.postcode,
            gender: this.setupData.gender,
            ageGroup: this.setupData.age,
            yearOfBirth: null,
            equityExperience: this.setupData.experienceShares,
            derivativesExperience: this.setupData.experienceOptions,
            interests: [],
            brokers: this.setupData.brokerName,
            sophisticatedOrWholesale: this.setupData.sophisticatedOrWholesale
        };
    }

    openBrokerList() {
        this.isBrokerListOpen = true;
    }

    closeBrokerList() {
        this.isBrokerListOpen = false;
    }

    setBroker(broker) {
        this.setupData.brokerName = broker.title;
        this.closeBrokerList();
    }

    setManualBroker() {
        this.setupData.brokerName = this.manualBroker;
        this.closeBrokerList();
    };
}
